import React from 'react';
import './about.css';

// १. मजकूर/डेटा एका ऑब्जेक्टमध्ये (Data Object) ठेवणे
// (यामुळे कॉम्पोनंट लॉजिक आणि मजकूर वेगळे राहतात)
const aboutUsData = {
  title: "गट ग्रामपंचायत सावंगी-घोगली: प्रगतीचा संकल्प",
  intro: "गट ग्रामपंचायत सावंगी-घोगली कळमेश्वर तालुक्यात असलेले, संस्कृती आणि कृषीचे उत्तम मिश्रण असलेले गाव आहे. स्थानिक स्वराज्य संस्था म्हणून आम्ही, गट ग्रामपंचायत सावंगी-घोगली एक आदर्श, आत्मनिर्भर आणि तंत्रज्ञान-स्नेही गाव बनवण्यासाठी कटिबद्ध आहोत.",
  visionTitle: "💡 आमची दृष्टी (Our Vision)",
  vision: [
    { icon: "🌐", title: "डिजिटल ग्राम", description: "ग्रामपंचायतीचे कामकाज पारदर्शक (Transparent) आणि डिजिटल माध्यमांतून चालवणे." },
    { icon: "🌿", title: "पर्यावरण पूरक विकास", description: "गावातील स्वच्छता, पाणी व्यवस्थापन आणि नैसर्गिक संसाधनांचे संरक्षण करणे." },
    { icon: "🤝", title: "युवा आणि महिला सबलीकरण", description: "शिक्षण, आरोग्य आणि रोजगाराच्या संधी उपलब्ध करून तरुण आणि महिलांना सशक्त करणे." },
  ],
  servicesTitle: "🏗 सेवा आणि सुविधा",
  services: [
    "पायाभूत सुविधा: उत्तम रस्ते, २४x७ पाणीपुरवठा आणि सार्वजनिक बांधकाम.",
    "दाखले आणि नोंदी: जन्म-मृत्यू, रहिवासी आणि विविध शासकीय दाखले वेळेत देणे.",
    "शासकीय योजना: केंद्र आणि राज्य सरकारच्या महत्त्वाकांक्षी योजनांचा लाभ थेट लाभार्थ्यांपर्यंत पोहोचवणे.",
  ],
  participation: {
    heading: "🤝 तुमचा सहभाग महत्त्वाचा",
    content: "ग्रामपंचायत म्हणजे केवळ कार्यालय नव्हे; ती गावकऱ्यांची संस्था आहे. आम्ही ग्रामसभेला सर्वाधिक महत्त्व देतो, कारण गावचा विकास हा केवळ प्रशासनाचा नाही, तर सामूहिक जबाबदारीचा विषय आहे. चला, आपण सारे मिळून, 'गोंडीदिग्रस' ला महाराष्ट्रातील एक 'प्रगत ग्राम' म्हणून ओळख मिळवून देऊया."
  },
  sarpanch: {
    name: "सौ.निताताई तभाने",
    slogan: "👉 'प्रत्येक नागरिकाच्या आवाजाला महत्त्व'",
    message: "मी, सौ. निताताई तभाने, गट ग्रामपंचायत सावंगी-घोगली नेतृत्वाची जबाबदारी स्वीकारताना हे सुनिश्चित केले आहे की, ग्रामपंचायतीचे दरवाजे प्रत्येक सामान्य नागरिकासाठी खुले असतील. माझ्या नेतृत्वाखालील कारभार 'ऑफिस-केंद्रित' नसून, 'जनता-केंद्रित' आहे.",
    successTitle: "🎯 आमच्या कारभाराचे यशोगाथा (Success Stories)",
    successStories: [
      { heading: "जबाबदार पाणी व्यवस्थापन", detail: "पाणी आडवा, पाणी जिरवा या तत्त्वावर काम करत, आम्ही जलसंधारणाचे मोठे काम पूर्ण केले, ज्यामुळे भूजल पातळी वाढण्यास मदत झाली." },
      { heading: "प्रदूषण नियंत्रण", detail: "गावातील सार्वजनिक ठिकाणी थुंकण्यास बंदी आणि प्लास्टिक वापराचे कठोर नियम लागू केले, ज्यामुळे स्वच्छता वाढली." },
      { heading: "सुलभ सेवा", detail: "ग्रामपंचायतीच्या सेवांमध्ये लागणारा वेळ कमी करून, कोणताही दाखला आता जास्तीत जास्त ४८ तासांत देण्याची प्रक्रिया सुरू केली." }
    ],
    youthTitle: "🌱 गावातील तरुणांसाठी गुंतवणूक",
    youthInvestment: [
      { heading: "डिजिटल कौशल्ये", detail: "कॉम्प्युटर प्रशिक्षण वर्ग सुरू करणे आणि त्यांना सरकारी नोकऱ्यांसाठी तयारी करण्यास मदत करणे." },
      { heading: "आरोग्य आणि खेळ", detail: "सार्वजनिक व्यायामशाळा (Open Gym) आणि खेळाचे मैदान विकसित करणे, जेणेकरून तरुणांचे आरोग्य उत्तम राहील." }
    ],
    closing: "गट ग्रामपंचायत सावंगी-घोगली नागरिकांचे प्रेम आणि विश्वास हीच माझ्या कामाची खरी प्रेरणा आहे. आपण मिळून, आपला विकास निश्चित करूया."
  }
};

// २. पुन्हा वापरता येण्याजोगा 'व्हिजन आयटम' उप-घटक (Reusable Vision Item Component)
const VisionItem = ({ icon, title, description }) => (
  <div className="vision-card">
    <div className="vision-icon">{icon}</div>
    <h4 className="vision-title">{title}</h4>
    <p className="vision-description">{description}</p>
  </div>
);

// ३. मुख्य 'AboutUs' कॉम्पोनंट
const AboutUs = () => {
  const { sarpanch } = aboutUsData;

  return (
    <div className="page about-us-page">
      <header className="page-header">
        <h1>{aboutUsData.title}</h1>
        <p className="page-intro">{aboutUsData.intro}</p>
      </header>
      
      <main className="page-content-grid">
        
        {/* व्हिजन विभाग */}
        <section className="section vision-section">
          <h2>{aboutUsData.visionTitle}</h2>
          <div className="vision-cards-container">
            {aboutUsData.vision.map((item, index) => (
              <VisionItem key={index} {...item} />
            ))}
          </div>
        </section>

        {/* सेवा विभाग */}
        <section className="section services-section">
          <h2>{aboutUsData.servicesTitle}</h2>
          <ul className="service-list">
            {aboutUsData.services.map((service, index) => (
              <li key={index} className="service-item">{service}</li>
            ))}
          </ul>
        </section>

        {/* सहभाग विभाग */}
        <section className="section participation-section bg-light">
          <h3>{aboutUsData.participation.heading}</h3>
          <p>{aboutUsData.participation.content}</p>
        </section>

        {/* --- सरपंच संदेश विभाग (Sarpanch Section) --- */}
        <section className="section sarpanch-section">
          <div className="sarpanch-card">
            <h2 className="sarpanch-name">सन्माननीय सरपंच: {sarpanch.name}</h2>
            <p className="sarpanch-slogan">{sarpanch.slogan}</p>
            <p className="sarpanch-message">{sarpanch.message}</p>
          </div>
        </section>
        
        {/* यशोगाथा विभाग */}
        <section className="section success-stories-section">
          <h3>{sarpanch.successTitle}</h3>
          <div className="story-list">
            {sarpanch.successStories.map((story, index) => (
              <div key={index} className="story-item">
                <h4>{story.heading}</h4>
                <p>{story.detail}</p>
              </div>
            ))}
          </div>
        </section>
        
        {/* तरुणांसाठी गुंतवणूक विभाग */}
        <section className="section youth-investment-section bg-light">
          <h3>{sarpanch.youthTitle}</h3>
          <div className="investment-list">
            {sarpanch.youthInvestment.map((item, index) => (
              <div key={index} className="investment-item">
                <h4>{item.heading}</h4>
                <p>{item.detail}</p>
              </div>
            ))}
          </div>
        </section>

      </main>

      <footer className="page-footer">
        <p className="closing-note">*** {sarpanch.closing} ***</p>
      </footer>
    </div>
  );
};

export default AboutUs;